import React from "react";
import "./styles.css"; // Import styles from a common CSS file

const TermsOfService = () => {
  return (
    <div className="page">
      <div className="title">Terms of Service</div>
      <div className="content">
        <h2 className="section-title">Copyright Notice</h2>
        <p>© 2024 Trustica Labs. All Rights Reserved.</p>
        <p>
          QuickFix Pro is a trademark of Trustica Labs. Unauthorized copying,
          distribution, modification, or any other use of the content in this
          application is strictly prohibited.
        </p>
        <p>
          For permissions beyond the scope of this license, please contact us at
          <a href="mailto:trusticalabs@gmail.com" className="email">
            {" "}
            trusticalabs@gmail.com
          </a>
          .
        </p>

        <h2 className="section-title">Terms of Service (ToS)</h2>
        <h3 className="section-title">1. Acceptance of Terms</h3>
        <p>
          By accessing and using QuickFix Pro, you agree to comply with and be
          bound by these Terms of Service. If you do not agree to these terms,
          please do not use the application.
        </p>

        <h3 className="section-title">2. Description of Service</h3>
        <p>
          QuickFix Pro is an online repair guide for consumer electronics and
          gadgets. The app provides step-by-step instructions, tools, and
          community support to help users perform repairs.
        </p>

        <h3 className="section-title">3. Intellectual Property</h3>
        <p>
          All content, including but not limited to text, graphics, logos,
          images, and software, is the property of Trustica Labs or its content
          suppliers and is protected by international copyright laws.
          Unauthorized use of the content may violate copyright, trademark, and
          other laws.
        </p>

        <h3 className="section-title">4. User Content</h3>
        <p>
          By submitting content to QuickFix Pro, you grant Trustica Labs a
          non-exclusive, royalty-free, perpetual, and worldwide license to use,
          reproduce, modify, adapt, publish, translate, create derivative works
          from, distribute, and display such content.
        </p>

        <h3 className="section-title">5. Prohibited Conduct</h3>
        <p>
          You agree not to use QuickFix Pro for any unlawful purpose or in any
          way that could damage, disable, overburden, or impair the application.
          This includes but is not limited to:
        </p>
        <ul>
          <li>Distributing malware or other harmful software</li>
          <li>Engaging in spamming or phishing activities</li>
          <li>Infringing on the intellectual property rights of others</li>
        </ul>

        <h3 className="section-title">6. Disclaimer of Warranties</h3>
        <p>
          QuickFix Pro is provided "as is" and "as available" without warranties
          of any kind, either express or implied. Trustica Labs does not warrant
          that the app will be uninterrupted, error-free, or free of viruses or
          other harmful components.
        </p>

        <h3 className="section-title">7. Limitation of Liability</h3>
        <p>
          In no event shall Trustica Labs or its suppliers be liable for any
          indirect, incidental, special, consequential, or punitive damages
          arising out of or related to your use of or inability to use the
          application.
        </p>
        <h3 className="section-title">8. Changes to Terms of Service</h3>
        <p>
          Trustica Labs reserves the right to update these Terms of Service at
          any time. Your continued use of the application after such changes
          will constitute your acceptance of the new terms.
        </p>

        <h3 className="section-title">9. Governing Law</h3>
        <p>
          These Terms of Service shall be governed by and construed in
          accordance with the laws of the USA, without regard to its conflict of
          law principles.
        </p>

        <h3 className="section-title">10. Contact Information</h3>
        <p>
          If you have any questions about these Terms of Service, please contact
          us at
          <a href="mailto:trusticalabs@gmail.com" className="email">
            {" "}
            trusticalabs@gmail.com
          </a>
          .
        </p>
        <p>
          We are committed to providing prompt and transparent responses to any
          inquiries or concerns regarding these terms. Your feedback is
          important to us, and we aim to address any issues swiftly and
          effectively.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
